{
    "title": "List Of Users",
    "userList": {
        "email": "Email",
        "roleMapping": {
            "role": "Role",
            "applications": "Applications"
        },
        "module": "Modules (Dashboards)",
        "department": "Department",
        "division": "Division",
        "lastLogin": "Last Login",
        "lastIpAddress": "Login Location / IP Address",
        "online": "Current Login Status (Online/ Offline)",
        "loginCount7d": "Login count in Last 7 days",
        "loginCount30d": "Login count in Last 30 Days",
        "action": "Action"
    },
    "AddUserbuttonLable": "Add User"
}